// Drives the ambient light of the whole UI from how far the current loop has
// run toward the Day 512 deadline — the day the Necromancer's ritual puts the
// sun out. The world has no hour-of-day clock (advanceDays only ever increments
// a day counter), so "time of day" here is the loop's own arc: it opens at the
// dawn of Day 1 and slides toward an extinguished-sun night as the deadline
// nears. The light draining as the days run out is the dread the whole game is
// built around, made visible without a word — and it costs nothing, because it
// reads straight off the day counter the player is already planning against.

import { RITUAL_DEADLINE_DAY } from "./loopEngine"

export type TimeOfDay = "dawn" | "day" | "dusk" | "night"

/**
 * How far the given day has run toward the Day 512 deadline, as 0..1. This is
 * the single number the loop's whole "arc of one long day" is derived from: the
 * ambient light (via the phases below) and the celestial dial in the status
 * panel both read it, so the roundel's sun and the room's light move together.
 */
export function getLoopProgress(currentDay: number): number {
  const span = RITUAL_DEADLINE_DAY - 1
  return Math.min(1, Math.max(0, (currentDay - 1) / span))
}

/**
 * How far into the loop's single long day the given day sits, as a phase.
 * Most of a loop reads as full "day"; dusk gathers as the deadline nears and
 * night falls in the final stretch, so a player deep in a loop feels the light
 * going even before the countdown is ever spelled out to them.
 */
export function getTimeOfDay(currentDay: number): TimeOfDay {
  const progress = getLoopProgress(currentDay)
  if (progress < 0.12) return "dawn"
  if (progress < 0.55) return "day"
  if (progress < 0.8) return "dusk"
  return "night"
}
